import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { DELETED_CONTACT_AVATAR_INFO, type IAvatarInfo } from 'shared/ui'
import { type IResponseAnalyticsSurveyContactCustom } from 'entities/Analytics/api/types'
import { Tag } from 'entities/Tags/model/Tag'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'

export class SurveyContactRow extends RowBase<IResponseAnalyticsSurveyContactCustom> {
  readonly tags: Tag[]

  constructor(origin: IResponseAnalyticsSurveyContactCustom) {
    super(origin)
    this.tags = Array.isArray(origin.tags) ? origin.tags.map(Tag.Create) : []
    makeObservableRowBase(this)

    if (origin.contact_id === null) {
      this.setCheckboxDisabled(true)
    }

    if (origin.contact_archived_at) {
      this.setDisabled(true)
      this.setCheckboxDisabled(true)
    }
  }

  get isDeleted() {
    return Boolean(this.origin.contact_archived_at)
  }

  get contact_id() {
    return this.origin.contact_id
  }

  get fullName() {
    return this.origin.contact_name
  }

  get formattedNumber() {
    return this.origin.contact_phone
  }

  get comment() {
    return this.origin.feedback_text
  }

  get score() {
    return this.origin.nps_score
  }

  get sent_at() {
    return this.origin.sent_at
  }

  get color() {
    return getUserAvatarColor(this.origin.contact_id ?? this.origin.execution_id)
  }

  get avatarInfo(): IAvatarInfo {
    if (this.isDeleted) {
      return DELETED_CONTACT_AVATAR_INFO
    }

    const isPhoneAbbr = !this.origin.contact_name

    return {
      isPhoneAbbr,
      firstName: this.origin.contact_name || '',
      image: '',
      color: this.color,
      number: this.formattedNumber || '',
    }
  }
}
